module.exports = __webpack_public_path__ + "static/palmmedicalcenters-87192d90d659973425b7b07cc942885d.jpg";